import { useEffect, useState } from "react";
import { getProductHighlightAvailability } from "@/api/public.api.js";

/**
 * Loads whether « Nouveaux articles » / « Articles restockés » menu entries should be shown.
 */
export function useProductHighlightAvailability() {
    const [hasNew, setHasNew] = useState(false);
    const [hasRestocked, setHasRestocked] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const response = await getProductHighlightAvailability();
                if (!cancelled) {
                    setHasNew(!!response?.hasNew);
                    setHasRestocked(!!response?.hasRestocked);
                }
            } catch {
                if (!cancelled) {
                    setHasNew(false);
                    setHasRestocked(false);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    return { hasNew, hasRestocked };
}
